<script>
import feather from "feather-icons";
import FooterCopyright from "./FooterCopyright.vue";

export default {
  components: { FooterCopyright },

  mounted() {
    feather.replace();
  },
  updated() {
    feather.replace();
  },
};
</script>

<template>
  <div class="w-full px-4 sm:px-6 lg:px-8 xl:max-w-[1400px] xl:mx-auto">
    <div
      class="pt-8 sm:pt-10 pb-8 mt-8 border-t-2 border-primary-light dark:border-secondary-dark"
    >
      <FooterCopyright />
    </div>
  </div>
</template>

<style scoped></style>
